import React from 'react';
import { Route as RouteIcon, ArrowRight } from 'lucide-react';
import { SideDrawer } from './SideDrawer';

const chip = (bg, fg) => ({ display: 'inline-block', padding: '2px 8px', borderRadius: 999, fontSize: 11, fontWeight: 600, background: bg, color: fg });

export default function JourneyDetailDrawer({ journey, onViewEnrolments, onClose }) {
  return (
    <SideDrawer testId="journey-drawer" icon={RouteIcon} kicker="Learning journey" title={journey.name}
      subtitle={[journey.solution_area, journey.target_audience, journey.duration != null ? `${journey.duration} h` : null].filter(Boolean).join(' · ')}
      onClose={onClose}>
      {journey.key_outcomes && (
        <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10, padding: 14, fontSize: 13, color: '#334155', marginBottom: 16 }} data-testid="journey-drawer-outcomes">
          <div style={{ fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', marginBottom: 4 }}>Key outcomes</div>
          {journey.key_outcomes}
        </div>
      )}
      <button className="btn btn-primary" onClick={() => onViewEnrolments(journey.id)} data-testid="journey-drawer-view-enrolments-btn"
        style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginBottom: 20 }}>
        View enrolments <ArrowRight size={14} />
      </button>
      {(journey.phases || []).map((ph, pi) => (
        <div key={ph.id} data-testid={`journey-drawer-phase-${ph.id}`} style={{ marginBottom: 18 }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 8 }}>
            <span style={{ fontSize: 11, fontWeight: 700, color: '#4338ca' }}>PHASE {pi + 1}</span>
            <span style={{ fontSize: 15, fontWeight: 700, color: '#0f172a' }}>{ph.name}</span>
            <span style={{ fontSize: 12, color: '#64748b' }}>· {(ph.activities || []).length} activities</span>
          </div>
          {ph.description && <div style={{ fontSize: 12, color: '#64748b', marginBottom: 8 }}>{ph.description}</div>}
          <div style={{ border: '1px solid #e2e8f0', borderRadius: 8 }}>
            {(ph.activities || []).map((a, ai) => (
              <div key={a.id} data-testid={`journey-drawer-activity-${a.id}`} style={{ padding: '10px 14px', borderTop: ai ? '1px solid #f1f5f9' : 'none', display: 'flex', gap: 12, justifyContent: 'space-between' }}>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#0f172a' }}>{a.name}</div>
                  {a.course && (
                    <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }} title={a.course.description || ''}>
                      Course <span style={{ fontFamily: 'monospace' }}>{a.course.course_id}</span>
                      {a.course.course_duration ? ` · ${a.course.course_duration}` : ''}
                      {a.course.targeted_audience ? ` · ${a.course.targeted_audience}` : ''}
                    </div>
                  )}
                </div>
                <span style={a.is_optional ? chip('#f1f5f9', '#64748b') : chip('#eef2ff', '#4338ca')}>{a.is_optional ? 'Optional' : 'Required'}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </SideDrawer>
  );
}
